$(document).ready(function() {
    // Toggle Menu
    $('.dropdown-btn').on('click', function(e) {
        e.stopPropagation();
        const $container = $(this).closest('.custome-dropdown');
        const $menu = $container.find('.dropdown-menu');
        const isExpanded = $(this).attr('aria-expanded') === 'true';

        // Close all other open dropdowns first
        $('.dropdown-btn').attr('aria-expanded', 'false');
        $('.dropdown-menu').hide();

        // Toggle current
        $(this).attr('aria-expanded', !isExpanded);
        $menu.toggle(!isExpanded);
    });

    // Handle Selection (Click and Keyboard)
    $('.dropdown-menu li').on('click keydown', function(e) {
        // Only trigger on click or Enter/Space keys
        if (e.type === 'keydown' && e.key !== 'Enter' && e.key !== ' ') return;
        
        if (e.key === ' ') e.preventDefault(); // Prevent scroll on Space

        const $li = $(this);
        const $container = $li.closest('.custome-dropdown');
        const $btn = $container.find('.dropdown-btn');
        const $selectedText = $container.find('.selected-text');
        const val = $li.data('value');

        // Update UI
        $selectedText.text(val);
        
        // Update ARIA
        $li.siblings().attr('aria-selected', 'false');
        $li.attr('aria-selected', 'true');
        
        // Close menu and return focus
        $btn.attr('aria-expanded', 'false').focus();
        $li.parent().hide();
    });

    // Close when clicking anywhere else
    $(document).on('click', function() {
        $('.dropdown-btn').attr('aria-expanded', 'false');
        $('.dropdown-menu').hide();
    });
});